import { styled } from '@goodfynd/theme';

export const StyledContainer = styled('section', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '32px 24px',
  '@mdMax': {
    gap: 24,
  },
});

export const StyledContent = styled('div', {
  border: '1px solid $Neutral05',
  borderRadius: 6,
  flexGrow: 1,
  padding: 24,
  '@lgMin': {
    maxWidth: '50%',
  },
  '@mdMax': {
    flexBasis: '100%',
  },
});
